import React, {useEffect, useState,} from "react";
import { useSelector, useDispatch } from "react-redux";
import { addComment, deleteComment,getCommentById} from "api/comments";
import Dropdown from 'react-bootstrap/Dropdown';
import Toast from "components/ToastComponent";
import { getActivityListByWorkFlowID} from "api/activity";
// import { resetActivityListState } from "redux/activityListReducer";
import {setdeleteComment,setSelectedComment,setSelectedCommentAttachment} from "redux/commentsReducer";
import "./index.scss";

const removeHTMLTAggs = (str) => {
  if (str === null || str === "") return false;
  else str = str.toString();
  return str.replace(/<[^>]*>/g, "");
};

const CommentMsg = ({
  comment,
  index,
  userName,
  attachments,
  created_by,
  setOrginalFileName,
  setImageSource,
  setShowModal,
  userRole,
  commentId,
  createdBy,
  parentId,
  parentBody,
  parentUsername,
  emailId,
  refreshFunction
}) => {
  const name =
    userName && userName !== "undefined undefined" && userName.split(" ");
  const start = useSelector((state) => state?.commentsReducer?.start);
  const limit = useSelector((state) => state?.commentsReducer?.limit);
  const sortBy = useSelector((state) => state?.commentsReducer?.sortBy);
  const sortOrder = useSelector((state) => state?.commentsReducer?.sortOrder);
  const params = useSelector((state) => state?.urlEncryption?.urlParams);
  const dispatch = useDispatch();
  const fullName  = name.filter(item => item != '')
  const firstletter = fullName && fullName[0].slice(0, 1).toUpperCase();
  const lastletter = fullName && fullName[1]?.slice(0, 1).toUpperCase();
  const [show, setShow] = React.useState(true);
  // function when given a Id returns the role name
  const profileData = useSelector(
    (state) => state?.loggedInUserInfo?.userAuthInfo
  )?.profileInfo;


  useEffect(() => {
    editAccess()
  }, [createdBy])
  const editAccess = () =>{
    if(createdBy === profileData?.userId){
      return setShow(true)
    }
  };

  const showReply = () => {
    refreshFunction(userName,commentId,comment,emailId,attachments)
  }

  const getRoleName = (id, name) => {
    return userRole?.match(/\d+/g) ? name : userRole;
    // const role = roles.find((role) => role.id === id);
    // return role?.role_name || userRole?.match(/\d+/g) ? name : userRole;
  };
  const handleEditComment = (comment,commentId) => {
    const comments = {
      _id :commentId,
      message:comment,
    }
    dispatch(setSelectedComment(comments));
    const queryObj = {commentId : commentId}
    const result = dispatch(getCommentById(queryObj));
    result.then((data) => {
      if(data?.payload?.data?.attachments?.length >0){
        const attachments = data.payload.data.attachments;
        dispatch(setSelectedCommentAttachment(attachments))
      }
    	})
  };
  const handleDeleteComment = (commentId) => {
    if(!commentId) return
    let params={
      _id:commentId,
      start:start,
      limit:limit,
      sortBy:sortBy,
      sortOrder:sortOrder
    }
    dispatch(deleteComment(params));
    
  };
  const deleteCommenttoaster = useSelector(
    (state) => state?.commentsReducer?.deleteCommenttoaster
    );
    const selectedcomment = useSelector(
      (state) => state?.commentsReducer?.selectedcomment
      )
      useEffect(() => {
        if (deleteCommenttoaster) {
         
      getActivityListByWorkFlowID(params.primaryWorkflowId);      
      const commentListContainer = document.getElementById(
        "comment-list-container"
      );
      if (commentListContainer) {
        commentListContainer.scrollTop = 0;
      }
      // if (params.primaryWorkflowId !== undefined) {
      //   const workFlow_id = params.primaryWorkflowId;
      //   dispatch(resetActivityListState());
      //   dispatch(
      //     getActivityListByWorkFlowID({
      //       workFlow_id,
      //       start: 0,
      //       limit: 10,
      //       sortBy,
      //       sortOrder,
      //     })
      //   );
      // }
    }
  }, [deleteCommenttoaster]);

  const handleJumpToParent = (parentId) => {
    const element = document.getElementById(`comment-${parentId}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    // <div key={index} className="comment-text-container">
    //   <div className="commenter_container">
    //     <div
    //       style={{ display: "flex", borderWidth: "1px" }}
    //       className=".profile_image"
    //     >
    // <p className="bg-purple h-30px w-30px d-flex align-items-center justify-content-center rounded-circle fs-13px">
    //   {firstletter ? firstletter : "A"}
    //   {lastletter ? lastletter : "B"}
    // </p>
    //     </div>
    //     <div className="commenter">
    //       <p className="commenter_role">
    //         {userRole ? getRoleName(userRole, name) : name}{" "}
    //       </p>
    //       <p className="commenter_name">{name ? name : "Anonymous"}</p>
    //     </div>
    //   </div>
    //   <div className="commenter_message">
    //     <label className="break-work-when-exceeds">
    //       {comment ? removeHTMLTAggs(comment) : ""}
    //     </label>
    //   </div>
    //   {attachments?.length > 0 && (
    //     <div>
    //       <hr />
    //       {attachments.length > 0 && attachments.length === 1 ? (
    //         attachments.includes(null) ? null : (
    //           <strong>Attachment</strong>
    //         )
    //       ) : (
    //         <strong>Attachments</strong>
    //       )}
    //       {attachments.map((file, index) => (
    //         <div
    //           style={{
    //             display: "flex",
    //             flexDirection: "row",
    //             justifyContent: "start",
    //             alignItems: "center",
    //             color: "blue",
    //             cursor: "pointer",
    //             margin: "0.5rem 0",
    //             textDecoration: "underline",
    //           }}
    //           key={index}
    //           onClick={() => {
    //             setOrginalFileName(file?.original_filename);
    //             setImageSource(file?.encrypted_filename);
    //             setShowModal(true);
    //           }}
    //         >
    //           {file?.original_name}
    //         </div>
    //       ))}
    //     </div>
    //   )}
    // </div>
    <>
      <div key={index} className="px-3 bg-white mb-3 mt-6">
        <div className="d-flex">

<div className="w-100 border rounded comment-container p-3">

<div className="d-flex">
<p className="profile_name pt-1 h-30px w-30px d-flex align-items-center justify-content-center rounded-circle fs-10px fw-bold m-0">
            {firstletter ? firstletter : ""}
            {lastletter ? lastletter : " "}
            {/* {userRole ? getRoleName(userRole, name) : name}{" "} */}
          </p>

    <div className="d-flex justify-content-between w-100">
            <p className="comment-role m-0 fw-bold fs-14px text-muted m-2">
              {userRole ? getRoleName(userRole, name) : name}{" "}
            </p>
  </div>

            {show && (
              <Dropdown>
                <Dropdown.Toggle
                  variant="white"
                  id="dropdown-basic"
                  className="h-35px w-35px border-0 p-0 bg-light rounded-circle d-flex align-items-center justify-content-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-three-dots"
                    viewBox="0 0 16 16"
                  >
                    <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                  </svg>
                </Dropdown.Toggle>

                <Dropdown.Menu className="fs-15px min-w-100px border-0 shadow-sm z-index-5">
                    <Dropdown.Item
                  className="bg-active-grey" onClick={showReply}>
                    Reply
                  </Dropdown.Item>
                  <Dropdown.Item
                  className="bg-active-grey"
                    onClick={() =>
                      handleEditComment(removeHTMLTAggs(comment), commentId)
                    }
                  >
                    Edit
                  </Dropdown.Item>
                  <Dropdown.Item
                  className="bg-active-grey" onClick={() => handleDeleteComment(commentId)}>
                    Delete
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
          </div>

          {parentBody && (
        <div className="border rounded p-2 mb-2 bg-white" onClick={() => handleJumpToParent(parentId)}>
          <p className="fw-bold mb-0">{parentUsername}</p>
          <p className="fs-14px mb-0">{parentBody}</p>
        </div>
      )}

{!parentBody && attachments?.length > 0 && (
  <>            
            {attachments.filter(file => file!= null).map((file, index) => (
            <div className="border rounded p-2 mb-2 bg-white">
             <div className="d-flex">
              <div className="icon">
              <svg id="Group_42481" data-name="Group 42481" xmlns="http://www.w3.org/2000/svg" width="23.801" height="28.56" viewBox="0 0 23.801 28.56">
  <g id="Group_34094" data-name="Group 34094" opacity="0.3">
    <path id="Path_24540" data-name="Path 24540" d="M1073.761,1235.86a2.458,2.458,0,0,1-2.454-2.454V1230h-10.964a3.2,3.2,0,0,0-3.2,3.2v19.3a3.2,3.2,0,0,0,3.2,3.2h13.162a3.2,3.2,0,0,0,3.2-3.2v-16.646Z" transform="translate(-1057.14 -1230)" fill="#ffdfb3"/>
  </g>
  <path id="Path_24541" data-name="Path 24541" d="M1181.59,1235.86h-2.946a2.458,2.458,0,0,1-2.454-2.454V1230Z" transform="translate(-1162.023 -1230)" fill="#ff9908"/>
  <path id="Path_24542" data-name="Path 24542" d="M1116.781,1400.6H1101.9a1.911,1.911,0,0,0-1.911,1.911v4.436a1.911,1.911,0,0,0,1.911,1.911h14.88a1.911,1.911,0,0,0,1.911-1.911v-4.436A1.911,1.911,0,0,0,1116.781,1400.6Z" transform="translate(-1094.891 -1380.298)" fill="#ff9908"/>
  <path id="Path_24543" data-name="Path 24543" d="M1130.506,1443.37v.866h-.9v-.866Z" transform="translate(-1120.987 -1417.979)" fill="#fff"/>
  <path id="Path_24544" data-name="Path 24544" d="M1142.556,1423.338a1.016,1.016,0,0,1-.425.379,1.5,1.5,0,0,1-.682.142,1.6,1.6,0,0,1-.991-.293,1.045,1.045,0,0,1-.307-.362,1.074,1.074,0,0,1-.118-.458h.921a.489.489,0,0,0,.144.319.445.445,0,0,0,.316.119.367.367,0,0,0,.263-.09.311.311,0,0,0,.1-.238.311.311,0,0,0-.021-.124.3.3,0,0,0-.068-.1.668.668,0,0,0-.22-.149q-.132-.059-.364-.139a4.66,4.66,0,0,1-.555-.225,1.009,1.009,0,0,1-.369-.325,1.053,1.053,0,0,1,.007-1.11,1.022,1.022,0,0,1,.449-.357,1.631,1.631,0,0,1,.655-.119,1.469,1.469,0,0,1,.952.283,1.088,1.088,0,0,1,.4.762h-.937a.47.47,0,0,0-.13-.281.368.368,0,0,0-.13-.081.388.388,0,0,0-.151-.022.354.354,0,0,0-.245.081.314.314,0,0,0-.074.108.3.3,0,0,0-.02.13.3.3,0,0,0,.02.115.32.32,0,0,0,.064.1.638.638,0,0,0,.209.145c.084.037.206.085.364.142a3.858,3.858,0,0,1,.562.23,1.1,1.1,0,0,1,.375.332.957.957,0,0,1,.157.566A.98.98,0,0,1,1142.556,1423.338Z" transform="translate(-1130.158 -1397.566)" fill="#fff"/>
  <path id="Path_24545" data-name="Path 24545" d="M1165.327,1420.58l.875,2.692.876-2.692H1168l-1.246,3.578h-1.119l-1.24-3.578Z" transform="translate(-1151.636 -1397.901)" fill="#fff"/>
  <path id="Path_24546" data-name="Path 24546" d="M1199.451,1420.481a1.406,1.406,0,0,1,.543.891h-.916a.7.7,0,0,0-.278-.306.886.886,0,0,0-1.109.157,1.07,1.07,0,0,0-.248.746,1.092,1.092,0,0,0,.261.784.976.976,0,0,0,.342.215,1,1,0,0,0,.4.058.893.893,0,0,0,.541-.17.9.9,0,0,0,.33-.483h-1.094v-.623h1.817v.856a1.758,1.758,0,0,1-.324.582,1.683,1.683,0,0,1-.57.436,1.814,1.814,0,0,1-.791.167,1.884,1.884,0,0,1-.952-.23,1.573,1.573,0,0,1-.625-.646,2.156,2.156,0,0,1,0-1.9,1.581,1.581,0,0,1,.622-.646,1.847,1.847,0,0,1,.939-.23A1.782,1.782,0,0,1,1199.451,1420.481Z" transform="translate(-1179.966 -1397.514)" fill="#fff"/>
  <g id="Group_44225" data-name="Group 44225" transform="translate(2.465 10.033)">
    <path id="Path_24547" data-name="Path 24547" d="M1108.7,1322.005h-.3a4.53,4.53,0,0,0-9.059,0h-.3a4.827,4.827,0,0,1,9.653,0Z" transform="translate(-1096.528 -1316.837)" fill="#d68107"/>
    <path id="Path_24548" data-name="Path 24548" d="M1095.7,1317.18H1081.98v.3H1095.7Z" transform="translate(-1081.489 -1316.837)" fill="#d68107"/>
    <path id="Path_24549" data-name="Path 24549" d="M1097.259,1353.75h-.948v.948h.948Z" transform="translate(-1094.115 -1349.056)" fill="#d68107"/>
    <path id="Path_24550" data-name="Path 24550" d="M1175.878,1353.75h-.948v.948h.948Z" transform="translate(-1163.379 -1349.056)" fill="#d68107"/>
    <path id="Path_24551" data-name="Path 24551" d="M1136.568,1314.31h-.948v.948h.948Z" transform="translate(-1128.745 -1314.31)" fill="#d68107"/>
    <path id="Path_24552" data-name="Path 24552" d="M1078.335,1315.26a.475.475,0,1,0-.475-.475A.475.475,0,0,0,1078.335,1315.26Z" transform="translate(-1077.86 -1314.31)" fill="#d68107"/>
    <path id="Path_24553" data-name="Path 24553" d="M1193.345,1315.26a.475.475,0,1,0-.475-.475A.475.475,0,0,0,1193.345,1315.26Z" transform="translate(-1179.183 -1314.31)" fill="#d68107"/>
  </g>
</svg>
              </div>
               <p
                className="fs-14px m-0 text-primary cursor-pointer"
                key={index}
                onClick={() => {
                  setOrginalFileName(file?.original_filename);
                  setImageSource(file?.encrypted_filename);
                  setShowModal(true);
                }}
              >
                <u> {file?.original_name}</u>
              </p>
             </div>
             </div>
            ))}
          </>
        )}

  <div className="comment-body">
  <p className="fs-14px comment-text">
    {comment ? removeHTMLTAggs(comment) : ""}
  </p>
</div>
{parentBody && attachments?.length > 0 && (
  <>
            {attachments.filter(file => file!= null).map((file, index) => (
            <div className="border rounded p-2 mb-2 bg-white" onClick={() => handleJumpToParent(parentId)}>
             <div className="d-flex">
              <div className="icon">
              <svg id="Group_42481" data-name="Group 42481" xmlns="http://www.w3.org/2000/svg" width="23.801" height="28.56" viewBox="0 0 23.801 28.56">
  <g id="Group_34094" data-name="Group 34094" opacity="0.3">
    <path id="Path_24540" data-name="Path 24540" d="M1073.761,1235.86a2.458,2.458,0,0,1-2.454-2.454V1230h-10.964a3.2,3.2,0,0,0-3.2,3.2v19.3a3.2,3.2,0,0,0,3.2,3.2h13.162a3.2,3.2,0,0,0,3.2-3.2v-16.646Z" transform="translate(-1057.14 -1230)" fill="#ffdfb3"/>
  </g>
  <path id="Path_24541" data-name="Path 24541" d="M1181.59,1235.86h-2.946a2.458,2.458,0,0,1-2.454-2.454V1230Z" transform="translate(-1162.023 -1230)" fill="#ff9908"/>
  <path id="Path_24542" data-name="Path 24542" d="M1116.781,1400.6H1101.9a1.911,1.911,0,0,0-1.911,1.911v4.436a1.911,1.911,0,0,0,1.911,1.911h14.88a1.911,1.911,0,0,0,1.911-1.911v-4.436A1.911,1.911,0,0,0,1116.781,1400.6Z" transform="translate(-1094.891 -1380.298)" fill="#ff9908"/>
  <path id="Path_24543" data-name="Path 24543" d="M1130.506,1443.37v.866h-.9v-.866Z" transform="translate(-1120.987 -1417.979)" fill="#fff"/>
  <path id="Path_24544" data-name="Path 24544" d="M1142.556,1423.338a1.016,1.016,0,0,1-.425.379,1.5,1.5,0,0,1-.682.142,1.6,1.6,0,0,1-.991-.293,1.045,1.045,0,0,1-.307-.362,1.074,1.074,0,0,1-.118-.458h.921a.489.489,0,0,0,.144.319.445.445,0,0,0,.316.119.367.367,0,0,0,.263-.09.311.311,0,0,0,.1-.238.311.311,0,0,0-.021-.124.3.3,0,0,0-.068-.1.668.668,0,0,0-.22-.149q-.132-.059-.364-.139a4.66,4.66,0,0,1-.555-.225,1.009,1.009,0,0,1-.369-.325,1.053,1.053,0,0,1,.007-1.11,1.022,1.022,0,0,1,.449-.357,1.631,1.631,0,0,1,.655-.119,1.469,1.469,0,0,1,.952.283,1.088,1.088,0,0,1,.4.762h-.937a.47.47,0,0,0-.13-.281.368.368,0,0,0-.13-.081.388.388,0,0,0-.151-.022.354.354,0,0,0-.245.081.314.314,0,0,0-.074.108.3.3,0,0,0-.02.13.3.3,0,0,0,.02.115.32.32,0,0,0,.064.1.638.638,0,0,0,.209.145c.084.037.206.085.364.142a3.858,3.858,0,0,1,.562.23,1.1,1.1,0,0,1,.375.332.957.957,0,0,1,.157.566A.98.98,0,0,1,1142.556,1423.338Z" transform="translate(-1130.158 -1397.566)" fill="#fff"/>
  <path id="Path_24545" data-name="Path 24545" d="M1165.327,1420.58l.875,2.692.876-2.692H1168l-1.246,3.578h-1.119l-1.24-3.578Z" transform="translate(-1151.636 -1397.901)" fill="#fff"/>
  <path id="Path_24546" data-name="Path 24546" d="M1199.451,1420.481a1.406,1.406,0,0,1,.543.891h-.916a.7.7,0,0,0-.278-.306.886.886,0,0,0-1.109.157,1.07,1.07,0,0,0-.248.746,1.092,1.092,0,0,0,.261.784.976.976,0,0,0,.342.215,1,1,0,0,0,.4.058.893.893,0,0,0,.541-.17.9.9,0,0,0,.33-.483h-1.094v-.623h1.817v.856a1.758,1.758,0,0,1-.324.582,1.683,1.683,0,0,1-.57.436,1.814,1.814,0,0,1-.791.167,1.884,1.884,0,0,1-.952-.23,1.573,1.573,0,0,1-.625-.646,2.156,2.156,0,0,1,0-1.9,1.581,1.581,0,0,1,.622-.646,1.847,1.847,0,0,1,.939-.23A1.782,1.782,0,0,1,1199.451,1420.481Z" transform="translate(-1179.966 -1397.514)" fill="#fff"/>
  <g id="Group_44225" data-name="Group 44225" transform="translate(2.465 10.033)">
    <path id="Path_24547" data-name="Path 24547" d="M1108.7,1322.005h-.3a4.53,4.53,0,0,0-9.059,0h-.3a4.827,4.827,0,0,1,9.653,0Z" transform="translate(-1096.528 -1316.837)" fill="#d68107"/>
    <path id="Path_24548" data-name="Path 24548" d="M1095.7,1317.18H1081.98v.3H1095.7Z" transform="translate(-1081.489 -1316.837)" fill="#d68107"/>
    <path id="Path_24549" data-name="Path 24549" d="M1097.259,1353.75h-.948v.948h.948Z" transform="translate(-1094.115 -1349.056)" fill="#d68107"/>
    <path id="Path_24550" data-name="Path 24550" d="M1175.878,1353.75h-.948v.948h.948Z" transform="translate(-1163.379 -1349.056)" fill="#d68107"/>
    <path id="Path_24551" data-name="Path 24551" d="M1136.568,1314.31h-.948v.948h.948Z" transform="translate(-1128.745 -1314.31)" fill="#d68107"/>
    <path id="Path_24552" data-name="Path 24552" d="M1078.335,1315.26a.475.475,0,1,0-.475-.475A.475.475,0,0,0,1078.335,1315.26Z" transform="translate(-1077.86 -1314.31)" fill="#d68107"/>
    <path id="Path_24553" data-name="Path 24553" d="M1193.345,1315.26a.475.475,0,1,0-.475-.475A.475.475,0,0,0,1193.345,1315.26Z" transform="translate(-1179.183 -1314.31)" fill="#d68107"/>
  </g>
</svg>
              </div>
               <p
                className="fs-14px m-0 text-primary cursor-pointer"
                key={index}
                onClick={() => {
                  setOrginalFileName(file?.original_filename);
                  setImageSource(file?.encrypted_filename);
                  setShowModal(true);
                }}
              >
                <u> {file?.original_name}</u>
              </p>
             </div>
             </div>
            ))}
          </>
        )}
</div>
      </div>
      </div>
    </>
  );
};

export default CommentMsg;
